<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0008 17.0008V14.0008C17.0008 13.7174 17.0966 13.4799 17.2883 13.2883C17.4799 13.0966 17.7174 13.0008 18.0008 13.0008C18.2841 13.0008 18.5216 13.0924 18.7133 13.2758C18.9049 13.4591 19.0008 13.6924 19.0008 13.9758V18.0008C19.0008 18.2841 18.9049 18.5216 18.7133 18.7133C18.5216 18.9049 18.2841 19.0008 18.0008 19.0008H6.85078L7.67578 19.8258C7.87578 20.0258 7.97995 20.2674 7.98828 20.5508C7.99661 20.8341 7.90078 21.0758 7.70078 21.2758C7.50078 21.4758 7.26328 21.5758 6.98828 21.5758C6.71328 21.5758 6.48411 21.4841 6.30078 21.3008L3.70078 18.7008C3.51745 18.5174 3.42578 18.2841 3.42578 18.0008C3.42578 17.7174 3.51745 17.4841 3.70078 17.3008L6.27578 14.7258C6.47578 14.5258 6.71328 14.4258 6.98828 14.4258C7.26328 14.4258 7.50078 14.5258 7.70078 14.7258C7.90078 14.9258 8.00078 15.1633 8.00078 15.4383C8.00078 15.7133 7.90078 15.9508 7.70078 16.1508L6.85078 17.0008H17.0008ZM7.00078 7.00078V10.0008C7.00078 10.2841 6.90495 10.5216 6.71328 10.7133C6.52161 10.9049 6.28411 11.0008 6.00078 11.0008C5.71745 11.0008 5.47995 10.9091 5.28828 10.7258C5.09661 10.5424 5.00078 10.3091 5.00078 10.0258V6.00078C5.00078 5.71745 5.09661 5.47995 5.28828 5.28828C5.47995 5.09661 5.71745 5.00078 6.00078 5.00078H17.1508L16.3258 4.17578C16.1258 3.97578 16.0216 3.73411 16.0133 3.45078C16.0049 3.16745 16.1008 2.92578 16.3008 2.72578C16.5008 2.52578 16.7383 2.42578 17.0133 2.42578C17.2883 2.42578 17.5174 2.51745 17.7008 2.70078L20.3008 5.30078C20.4841 5.48411 20.5758 5.71745 20.5758 6.00078C20.5758 6.28411 20.4841 6.51745 20.3008 6.70078L17.7258 9.27578C17.5258 9.47578 17.2883 9.57578 17.0133 9.57578C16.7383 9.57578 16.5008 9.47578 16.3008 9.27578C16.1008 9.07578 16.0008 8.83828 16.0008 8.56328C16.0008 8.28828 16.1008 8.05078 16.3008 7.85078L17.1508 7.00078H7.00078Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
